import Link from "next/link";
import { ChevronRight } from "lucide-react";
import { Container } from "./container";
import { cn } from "@/lib/utils";
import { siteUrl } from "@/lib/env";

interface BreadcrumbItem {
  label: string;
  href: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
  /** Białe okruszki na niebieskim hero „Sky". */
  onSky?: boolean;
}

export function Breadcrumbs({ items, className, onSky }: BreadcrumbsProps) {
  // Generate JSON-LD for breadcrumbs
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      item: `${siteUrl}${item.href}`,
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <Container className={cn("", className)}>
        <nav aria-label="Breadcrumb">
          <ol className={cn("flex flex-wrap items-center gap-1 sm:gap-2 text-sm", onSky ? "text-white/75" : "text-muted-foreground")}>
            {items.map((item, index) => (
              <li key={item.href} className="flex items-center gap-1 sm:gap-2">
                {index > 0 && (
                  <ChevronRight className={cn("h-4 w-4 shrink-0", onSky ? "text-white/50" : "text-muted-foreground/50")} />
                )}
                {index === items.length - 1 ? (
                  <span className={cn("font-medium line-clamp-1", onSky ? "text-white" : "text-foreground")}>
                    {item.label}
                  </span>
                ) : (
                  <Link
                    href={item.href}
                    className={cn("transition-colors whitespace-nowrap", onSky ? "hover:text-white" : "hover:text-foreground")}
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </Container>
    </>
  );
}
